export enum THEME {
    Light = 'light',
    Dark = 'dark'
}
